export const V1 = 'v1'
export const V2 = 'v2'
export const V3 = 'v3'
export const SuspicionsDiagnosSourceModel = 'Webiomed.DirectModelsAccess.WML.SymptomChecker'
export const ResultRiskMethodsSourceModel = 'model'

export default { V1, V2, V3 }
